import React from 'react';
import { Table, TableContainer, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatCentsToUsd } from '../../../helpers/formatCentsToUsd';
import { useSort } from '../../../hooks/useSort';
import SortableHeaderCell from '../../../components/atom/SortableHeaderCell';

// Ranks affiliate agents by what they produced (default: total sales desc).
const AffiliateAgentReportTable = ({ items, totalSales, totalBookings }) => {
    const { t } = useTranslation();
    const sort = useSort(items, 'totalSales', 'desc');

    const totalPercentage = totalSales === 0 ? 0 : 100;

    return (
        <TableContainer sx={{ maxHeight: '65vh' }}>
            <Table stickyHeader sx={{ width: '100%', '& thead th': { top: 0 } }}>
                <TableHead>
                    <TableRow>
                        <SortableHeaderCell field="agentName" sort={sort}>
                            {t('reports.affiliateAgent.agentName')}
                        </SortableHeaderCell>
                        <SortableHeaderCell field="commissionGroupName" sort={sort}>
                            {t('reports.affiliateAgent.commissionGroup')}
                        </SortableHeaderCell>
                        <SortableHeaderCell field="bookingCount" sort={sort} align="right">
                            {t('reports.affiliateAgent.bookingCount')}
                        </SortableHeaderCell>
                        <SortableHeaderCell field="totalSales" sort={sort} align="right">
                            {t('reports.affiliateAgent.totalSales')}
                        </SortableHeaderCell>
                        <SortableHeaderCell field="percentageOfTotal" sort={sort} align="right">
                            {t('reports.affiliateAgent.percentageOfTotal')}
                        </SortableHeaderCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sort.sortedItems.map((item) => (
                        <TableRow key={item.agentId}>
                            <TableCell>{item.agentName ?? '-'}</TableCell>
                            <TableCell>
                                {item.commissionGroupName ?? t('reports.affiliateAgent.noGroup')}
                            </TableCell>
                            <TableCell align="right">{item.bookingCount}</TableCell>
                            <TableCell align="right">{formatCentsToUsd(item.totalSales)}</TableCell>
                            <TableCell align="right">
                                {item.percentageOfTotal.toFixed(2)}%
                            </TableCell>
                        </TableRow>
                    ))}
                    <TableRow sx={{ backgroundColor: 'action.selected' }}>
                        <TableCell colSpan={2}>
                            <strong>{t('reports.summary.grandTotal', 'Grand Total')}</strong>
                        </TableCell>
                        <TableCell align="right">
                            <strong>{totalBookings}</strong>
                        </TableCell>
                        <TableCell align="right">
                            <strong>{formatCentsToUsd(totalSales)}</strong>
                        </TableCell>
                        <TableCell align="right">
                            <strong>{totalPercentage.toFixed(2)}%</strong>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default AffiliateAgentReportTable;
